<template>
  <div class="hello">
    <!-- img tag를 이용한 일반적인 Image 생성. -->
    <viewer :images="this.image">
        <div class="gallary_image" :id="'imgBox'+i" v-for="(form, i) in this.image" :key="form.id">
            <span class="remove" v-on:click="deleteImgFile(form.id, i)"><i class="fa fa-times" aria-hidden="true"></i></span>
            <img class="gallary_image"  :id="form.id" v-bind:src="'data:'+form.type.trim()+';base64,'+ form.img"/>
        </div>
    </viewer>
  </div>
</template>

<script>
/* eslint-disable */
import common from '@/views/Common/common.js';
import { Buefy } from 'buefy';

export default {
  name: 'ImageViewer',
  props: ['image'],
  data () {
    return {
      images: this.image
    }
  },
  created() {
  },
  methods: {
      	/*
        * gel image file delete
        */
        async deleteImgFile(id, i) {
            this.$buefy.dialog.confirm({
                message: 'Would you like to delete?',
                size: 'is-medium',
                onConfirm: async () => {
                    //사진 지우는거 보여주기
                    var del = document.getElementById('imgBox'+i);
                    del.remove();
                    let param = {id: id, gubun: 'gel'};
                    this.$emit('deleteImgFile', param);
                },
                onCancel: () => {
                    id ='';
                }
            });
        },
  }
}
</script>

<style scoped>
.gallary_image {
  width: 180px;
  height: 180px;
  display: inline;
  margin: 2px 2px;
  cursor: pointer;
}

.remove {
    position: relative;
    margin-left: 5px;
    bottom: 75px;
    left: 180px;
}
.remove i {
    font-size: 20px;
    color: #FF5722;
    opacity: 0.5;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/views/Common/image-upload/Viewer.vue